async function sendStoryAnalytics({
  productUrl,
  // storyProductUrl,
  slideIndex,
  action,
  // muted,
  trackingId,
}) {
  const baseUrl = 'https://product-api.wonderdays.ae/api/products/story/analytics';
  const queryParams = new URLSearchParams({
    productUrl: productUrl,
    // storyProductUrl: encodeURIComponent(storyProductUrl),
    slideIndex,
    action,
    // muted,
    trackingId,
  });

  const fullUrl = `${baseUrl}?${queryParams.toString()}`;

  try {
    const response = await fetch(fullUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error sending story analytics:', error);
    return null;
  }
}
